export const updateConfig = (state, path, value) => {
  const newConfig = { ...state.config }
  let current = newConfig
  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i]
    current[key] = { ...current[key] }
    current = current[key]
  }
  current[path[path.length - 1]] = value
  return {
    ...state,
    stateHasChanged: true,
    config: newConfig
  }
}

export const updateNode = (state, nodeId, path, value) => {
  return {
    ...state,
    stateHasChanged: true,
    data: {
      ...state.data,
      nodes: state.data.nodes.map(node => {
        if (node.id !== nodeId) return node

        const updatedNode = { ...node }
        let target = updatedNode
        for (let i = 0; i < path.length - 1; i++) {
          const key = path[i]
          target[key] = { ...target[key] }
          target = target[key]
        }
        target[path[path.length - 1]] = value

        return updatedNode
      })
    }
  }
}

export const updateEdge = (state, edgeId, path, value) => {
  return {
    ...state,
    stateHasChanged: true,
    data: {
      ...state.data,
      edges: state.data.edges.map(edge => {
        if (edge.id !== edgeId) return edge

        const updatedEdge = { ...edge }
        let target = updatedEdge
        for (let i = 0; i < path.length - 1; i++) {
          const key = path[i]
          target[key] = { ...target[key] }
          target = target[key]
        }
        target[path[path.length - 1]] = value

        return updatedEdge
      })
    }
  }
}

export const setSidebarValue = (state, path, value) => {
  const editingToggles = ['styleEditItem', 'linkEditItem', 'displayAddNode', 'detailsItem']
  const otherOptions = editingToggles.filter(item => item !== path)

  return {
    ...state,
    stateHasChanged: true,
    [path]: (!!value?.id && value?.id === state[path]?.value?.id) ? null : value,
    ...(otherOptions.reduce((acc, item) => {
      acc[item] = null
      return acc
    }, {}))
  }
}

export const addLinkedEntityData = (state, levelTypeId, levelId, value) => {
  return {
    ...state,
    stateHasChanged: true,
    linkedEntityData: {
      ...state.linkedEntityData,
      [levelTypeId]: {
        ...(state.linkedEntityData?.[levelTypeId] ?? {}),
        [levelId]: value
      }
    }
  }
}

export const buildInitialLayout = (plugin, pluginConfig, level) => {
  const { levelId, levelTypeId } = level
  const clientId = levelTypeId === 201 ? levelId : null

  if (typeof plugin?.buildInitialLayout === 'function') {
    return plugin.buildInitialLayout({ config: pluginConfig, clientId })
  }
  const initial = plugin.createInitial(pluginConfig, clientId)
  return plugin?.layout({
    nodes: initial.nodes.map(n => ({ ...n })),
    edges: (initial.edges || []).map(e => ({ ...e })),
    centerId: initial.centerId,
    config: pluginConfig
  }) ?? { nodes: initial.nodes, edges: initial.edges || [] }
}
